<template>
  <b-modal
    id="feedback-support"
    ref="feedback-support"
    size="sm-size"
    modal-class="notes-modal"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{ label.get('feedback_support') }}
      </h2>
    </div>
    <div class="content-wrapper">
      <textarea
        v-model="message"
        name="notes"
        class="manual-entry-notes"
        minlength="5"
        maxlength="5000"
        :placeholder="label.get('add_message_here')+'…'"
      />
    </div>
    <div class="modal-footer">
      <!--<button
        type="reset"
        class="atto-btn cancel"
        @click="close"
      >
        {{ label.get('cancel') }}
      </button>-->
      <button
        type="submit"
        class="atto-btn submit"
        :disabled="disabledSaveButton"
        @click="saveNoteChanges"
      >
        {{ label.get('send_message') }}
      </button>
    </div>
  </b-modal>
</template>

<script>
    import FeedbackService from '../services/FeedbackService';
    export default {
        name: "FeedbackSupportComponent",
        data(){
            return{
                message: '',
                disabledSaveButton: false
            }
        },
        mounted() {
            this.$refs['feedback-support'].show();
        },
        methods: {
            close() {
                this.$root.$emit('hideFeedbackModal');
            },
            saveNoteChanges() {
                if(this.message.trim() === '') {
                    return false;
                }

                const data = {
                    stars: null,
                    message: this.message,
                    platform: 'Web'
                };

                this.disabledSaveButton = true;
                FeedbackService.sendFeedback(data).then((result) => {
                    this.$root.$emit('hideFeedbackModal');
                    this.$awn.success(
                        '<p class="bold">' + result.data.message.title + '</p>' +
                        '<p>' + result.data.message.description + '</p>'
                    );
                }).catch(() => {
                    this.disabledSaveButton = false;
                });
            }
        }
    }
</script>

<!--
<style lang="scss">
    #feedback-support {
        .modal-sm-size {
            .modal-footer {
                flex-direction: row;
            }

            .content-wrapper {
                textarea {
                    padding: 8px 12px;
                    width: 100%;
                    min-height: 160px;
                    border: 2px solid $atto-light-grey;
                    font-family: $roboto-font;
                    font-weight: $roboto-medium;
                    font-size: 0.875rem;
                    line-height: 1.25rem;
                    overflow-y: hidden;
                    @include base-transition(ease all 0.15s);
                    @include style-placeholder($atto-not-active);

                    &:focus{
                        border-color: $atto-dark-grey;
                        outline: 0;
                        box-shadow: none;
                    }
                }
            }
        }
    }
</style>-->
